import palette from '../theme/fingo/palette';

export const SEMAPHORE_COLORS = {
  green: palette.success.A700,
  yellow: palette.warning.main,
  red: palette.error.A800,
  pending: palette.gray.A400,
};

export const SEMAPHORE_TEXT_ES = {
  green: 'Verde',
  yellow: 'Amarillo',
  red: 'Rojo',
  pending: 'Pendiente',
};
